module.exports = __webpack_public_path__ + "static/media/agority.0575b301.jpg";